import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { DownloadIcon } from 'lucide-react';
interface StickyMobileCTAProps {
  onDownload: () => void;
}
export function StickyMobileCTA({
  onDownload
}: StickyMobileCTAProps) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 520);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-133">
      {show && <motion.div className="fixed inset-x-0 bottom-0 z-30 border-t border-charcoal/10 bg-cream/95 px-4 py-3 backdrop-blur lg:hidden" initial={{
      y: 80
    }} animate={{
      y: 0
    }} exit={{
      y: 80
    }} transition={{
      type: 'tween',
      duration: 0.25
    }} data-id="element-134">
          <button type="button" onClick={onDownload} className="flex w-full items-center justify-center gap-2 rounded-md bg-yellow px-5 py-3 text-sm font-bold text-charcoal" data-id="element-135">
            <DownloadIcon className="h-4 w-4" data-id="element-136" />
            Download Free Guide
          </button>
        </motion.div>}
    </AnimatePresence>;
}